<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/x0gZ6q/tc-custom/9781614754190.jpg?1704586003432" alt="This image is the cover for the book Officer, Wild Blue U"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Officer, Wild Blue U
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Timeless and absorbing. . . . An astonishing and authentic portrayal of the military academy experience.” —Jerry Pournelle, <i>New York Times</i>–bestselling, Nebula and Hugo Award–winning author of <i>Lucifer’s Hammer</i></b><br/><br/><i>The Officer</i> continues the historical saga chronicling the United States Air Force Academy. Unveiling the arduous training of America’s leaders, <i>The Officer </i>showcases empathetic, larger-than-life characters set against a fascinating tapestry of historical fact—vivid, history-changing events that affect the course of the nation, ranging from cheating scandals at the USAF Academy to the Cuban missile crisis to the jungles of Vietnam.<br/><br/> Praise for the Wild Blue U saga:<br/><br/> “Doug Beason has captured the essence of the lives of the early cadets and graduates of the Air Force Academy.” <i>—</i>General Ron Fogleman, USAFA Class of 1963, 15th Chief of Staff, USAF: first Academy graduate to become USAF Chief of Staff.<br/><br/> “Doug Beason has distilled the first years of the Air Force Academy into a compelling and fascinating novel. . . . The closest and most intimate account that exists in print, with all the turbulence and exuberance captured through the lens of fiction.” —Lt. Gen Brad Hosmer, USAF (ret), #1 Graduate of the USAFA Class of 1959, Rhoades Scholar and USAFA Superintendent </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Doug Beason
      </h2>
      
      <p class="authorDescription body article">Dr. Doug Beason is the author of thirteen novels as well as two non-fiction books. A Nebula Award finalist, Doug has published over 100 short stories and other work in publications as diverse as The Wall Street Journal, Analog, Amazing Stories, Physics of Fluids, and Physical Review Letters. A Fellow of the American Physical Society and Ph.D. physicist, Doug retired as the Associate Laboratory Director at the Los Alamos National Laboratory, where he was responsible for the people and programs that reduce the global threat of weapons of mass destruction. A retired USAF Colonel, Doug's last active duty assignment was the Commander of the Phillips Research Site and Deputy Director for Directed Energy at the Air Force Research Laboratory. He has worked on the White House staff for the President's Science Advisor, and was recently the Chief Scientist of US Air Force Space Command. A 1977 graduate of the USAF Academy, he served on the USAF Academy faculty as an Associate Professor of Physics and Director of Faculty Research.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0919aded